import { render } from "./deviceModels.vue?vue&type=template&id=5f210388&scoped=true"
import script from "./deviceModels.vue?vue&type=script&lang=js"
export * from "./deviceModels.vue?vue&type=script&lang=js"

import "./deviceModels.vue?vue&type=style&index=0&id=5f210388&lang=scss&scoped=true"

import exportComponent from "/home/jenkins-prod/worker1/workspace/jaka-digital/A-01-OTA/jaka-ota-admin-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f210388"]])

export default __exports__